export class CacheEntry<T> {
  private _timestamp: Date
  constructor(private _entity: T) {
    this._timestamp = new Date()
  }
  get timestamp() {
    return this._timestamp
  }

  get entity() {
    return this._entity
  }
}
